import {StatusPillVariants} from "../shared-components/constants/statusPillVariants"

export const commandeType = {
    DEMANDE_DE_SERVICE: "Prestation",
    COMMANDE_CESU: "CESU",
}

export const commandeStatut = {
    CREEE: "Créée",
    EN_ATTENTE: "En attente",
    EN_COURS_TRAITEMENT: "En cours de traitement",
    PRESTATAIRE_SELECTIONNE: "Prestataire sélectionné",
    TERMINEE: "Terminée",
    REFUSEE: "Refusée",
    SANS_SOLUTION: "Sans solution",
    ANNULEE: "Annulée",
}

export const commandeStatutStatusVariant = {
    [commandeStatut.CREEE]: StatusPillVariants.CONFIRME,
    [commandeStatut.EN_ATTENTE]: StatusPillVariants.EN_COURS,
    [commandeStatut.EN_COURS_TRAITEMENT]: StatusPillVariants.A_TRAITER,
    [commandeStatut.PRESTATAIRE_SELECTIONNE]: StatusPillVariants.A_TRAITER,
    [commandeStatut.TERMINEE]: StatusPillVariants.CLOTURE,
    [commandeStatut.REFUSEE]: StatusPillVariants.REFUSE,
    [commandeStatut.SANS_SOLUTION]: StatusPillVariants.REFUSE,
    [commandeStatut.ANNULEE]: StatusPillVariants.CLOTURE,
}

export const commandeTypeOption = [
    {key: 0, value: commandeType.DEMANDE_DE_SERVICE, text: commandeType.DEMANDE_DE_SERVICE},
    {key: 1, value: commandeType.COMMANDE_CESU, text: commandeType.COMMANDE_CESU},
]

export const statusOption = [
    {key: 0, value: commandeStatut.CREEE, text: commandeStatut.CREEE},
    {key: 1, value: commandeStatut.EN_ATTENTE, text: commandeStatut.EN_ATTENTE},
    {key: 2, value: commandeStatut.EN_COURS_TRAITEMENT, text: commandeStatut.EN_COURS_TRAITEMENT},
    {key: 3, value: commandeStatut.PRESTATAIRE_SELECTIONNE, text: commandeStatut.PRESTATAIRE_SELECTIONNE},
    {key: 4, value: commandeStatut.SANS_SOLUTION, text: commandeStatut.SANS_SOLUTION},
    {key: 5, value: commandeStatut.TERMINEE, text: commandeStatut.TERMINEE},
    {key: 6, value: commandeStatut.REFUSEE, text: commandeStatut.REFUSEE},
    {key: 7, value: commandeStatut.ANNULEE, text: commandeStatut.ANNULEE},
]

export const contractAditionnalFieldType = {
    DATE: "DATE",
    NUMERIQUE: "NUMERIQUE",
    ALPHANUMERIQUE: "ALPHANUMERIQUE",
    COMMENTAIRE: "COMMENTAIRE",
    CASE_A_COCHER: "CASE_A_COCHER",
    LISTE_DE_VALEURS: "LISTE_DE_VALEURS",
}
